import { getAuthData } from "./features/auth/session.js";
// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import { IconChevronLeft, IconChevronRight, IconX } from "./components/icons.jsx";
import { Se } from "./components/icons.jsx";
import { zv } from "./components/icons.jsx";
import { Ov } from "./assets.jsx";
import { kv } from "./assets.jsx";
import { Rv } from "./assets.jsx";
import { Bv } from "./assets.jsx";
import { Uv } from "./assets.jsx";
import { Hv } from "./assets.jsx";
import { Lv } from "./assets.jsx";
import { qv } from "./assets.jsx";
import { Gv } from "./assets.jsx";
import { Yv } from "./assets.jsx";
import { Xv } from "./assets.jsx";
import { Qv } from "./assets.jsx";
import { Zv } from "./assets.jsx";
import { Vv } from "./assets.jsx";
import { $v } from "./assets.jsx";
import { Kv } from "./assets.jsx";
import { Jv } from "./assets.jsx";
import { Wv } from "./assets.jsx";
import { Iv } from "./assets.jsx";
import { Fv } from "./assets.jsx";
import * as React from "react";
import * as jsxRuntime from "react/jsx-runtime";
import { IconArrowRight } from "./components/icons.jsx";
export const IconStarFilledFilled = Se("filled", "star-filled", "StarFilled", zv);
export const Ee = {
  logicalWidth: 360,
  logicalHeight: 540,
  maxDepth: 1e3,
  descendSpeed: 20,
  descendDepthBoost: 2.6,
  ascendSpeed: 46,
  quickAscendCatchCount: 5,
  quickAscendSpeed: 132,
  hookSpeed: 82,
  objectLimit: 40,
  fishSpawnDistance: 11,
  bombSpawnChance: .31,
  chestSpawnChance: .045,
  deepPrizeMinDepth: 720,
  deepPrizeChance: .075,
  deepPrizeReward: 180,
  bombCatchPenalty: .3,
  slicingDuration: 7.5,
  slicingBombChance: .12,
  slicingBombPenalty: .1,
  comboWindowMs: 650,
  comboMultipliers: [1, 1.1, 1.2, 1.3],
  surfaceY: 76
};
export const Do = [{
  id: "blue",
  rarity: "common",
  minDepth: 0,
  maxDepth: 1e3,
  reward: 6,
  spawnWeight: 20,
  color: "#54ddff",
  size: 20,
  image: Ov
}, {
  id: "turquoise",
  rarity: "common",
  minDepth: 0,
  maxDepth: 1e3,
  reward: 7,
  spawnWeight: 16,
  color: "#55ead9",
  size: 21,
  image: kv
}, {
  id: "clown",
  rarity: "uncommon",
  minDepth: 80,
  maxDepth: 1e3,
  reward: 14,
  spawnWeight: 12,
  color: "#ff9747",
  size: 22,
  image: Rv
}, {
  id: "green",
  rarity: "uncommon",
  minDepth: 110,
  maxDepth: 1e3,
  reward: 14,
  spawnWeight: 10,
  color: "#b0ef4d",
  size: 22,
  image: Bv
}, {
  id: "purple",
  rarity: "rare",
  minDepth: 240,
  maxDepth: 1e3,
  reward: 32,
  spawnWeight: 8,
  color: "#b980ff",
  size: 24,
  image: Uv
}, {
  id: "blue_gold",
  rarity: "rare",
  minDepth: 280,
  maxDepth: 1e3,
  reward: 36,
  spawnWeight: 7,
  color: "#6fb3ff",
  size: 24,
  image: Hv
}, {
  id: "pink",
  rarity: "rare",
  minDepth: 340,
  maxDepth: 1e3,
  reward: 38,
  spawnWeight: 6,
  color: "#ff7fc3",
  size: 25,
  image: Lv
}, {
  id: "gold",
  rarity: "epic",
  minDepth: 460,
  maxDepth: 1e3,
  reward: 74,
  spawnWeight: 4,
  color: "#ffd365",
  size: 26,
  image: qv
}, {
  id: "ice",
  rarity: "epic",
  minDepth: 540,
  maxDepth: 1e3,
  reward: 86,
  spawnWeight: 3,
  color: "#a5ecff",
  size: 27,
  image: Gv
}, {
  id: "red",
  rarity: "epic",
  minDepth: 600,
  maxDepth: 1e3,
  reward: 94,
  spawnWeight: 3,
  color: "#ff705f",
  size: 28,
  image: Yv
}, {
  id: "pufferfish",
  rarity: "rare",
  minDepth: 360,
  maxDepth: 1e3,
  reward: 43,
  spawnWeight: 5,
  color: "#ffdb6f",
  size: 28,
  image: Xv
}, {
  id: "jellyfish",
  rarity: "legendary",
  minDepth: 690,
  maxDepth: 1e3,
  reward: 180,
  spawnWeight: 2,
  color: "#7beeff",
  size: 30,
  image: Qv
}, {
  id: "squid",
  rarity: "legendary",
  minDepth: 790,
  maxDepth: 1e3,
  reward: 216,
  spawnWeight: 1,
  color: "#cf8cff",
  size: 31,
  image: Zv
}, {
  id: "shark",
  rarity: "legendary",
  minDepth: 880,
  maxDepth: 1e3,
  reward: 288,
  spawnWeight: 1,
  color: "#77caff",
  size: 34,
  image: Vv
}];
export const gn = {
  chest: $v,
  bomb: Kv
};
export const ys = {
  deepWater: Jv,
  surface: Wv,
  midwater: Iv,
  seafloor: Fv
};
export const Pv = () => ({
  caught: [],
  chests: 0,
  relics: 0,
  maxDepth: 0,
  sliced: 0,
  combo: 0,
  bestCombo: 0,
  reward: 0
});
export const Vt = (u, o) => u + Math.random() * (o - u);
export const yn = (u, o, m) => Math.max(o, Math.min(m, u));
export const eb = (u, o, m, r, g, j) => {
  const B = g - m,
    U = j - r,
    N = B * B + U * U,
    y = N ? yn(((u - m) * B + (o - r) * U) / N, 0, 1) : 0;
  return Math.hypot(u - (m + B * y), o - (r + U * y));
};
export async function Xi(u) {
  const o = await u.text();
  try {
    return {
      response: u,
      data: o ? JSON.parse(o) : {}
    };
  } catch {
    const m = u.status === 404 ? "Игровой API ещё не перезапущен. Обновите API-сервис." : `Сервис рыбалки вернул некорректный ответ (${u.status}).`;
    return {
      response: u,
      data: {
        error: m
      }
    };
  }
}
export function tb(u) {
  const o = Do.filter(g => u >= g.minDepth && u <= g.maxDepth),
    m = o.reduce((g, j) => g + j.spawnWeight, 0);
  let r = Math.random() * m;
  return o.find(g => (r -= g.spawnWeight) <= 0) ?? o[0];
}
export function sm() {
  return {
    phase: "idle",
    hookX: Ee.logicalWidth / 2,
    depth: 0,
    world: [],
    sliced: [],
    sliceQueue: [],
    stats: Pv(),
    spawnDepth: 28,
    nextId: 1,
    elapsed: 0,
    hintUntil: 0,
    shakeUntil: 0,
    rapidReturn: !1,
    ascentStartDepth: 0,
    trail: [],
    lastSlice: 0,
    left: !1,
    right: !1
  };
}
export function jo(u, o, m, r, g, j = 1, B = !1) {
  u.save(), u.translate(o, m), u.scale(j, 1), u.shadowColor = g, u.shadowBlur = 12, u.fillStyle = g, u.beginPath(), u.ellipse(0, 0, r, r * .62, 0, 0, Math.PI * 2), u.fill(), u.beginPath(), u.moveTo(-r * .72, 0), u.lineTo(-r * 1.35, -r * .65), u.lineTo(-r * 1.35, r * .65), u.closePath(), u.fill(), u.shadowBlur = 0, u.fillStyle = "#08213d", u.beginPath(), u.arc(r * .38, -r * .16, Math.max(1.7, r * .13), 0, Math.PI * 2), u.fill(), B && (u.strokeStyle = "#ecfbff", u.lineWidth = 2, u.beginPath(), u.moveTo(-r, -r), u.lineTo(r, r), u.stroke()), u.restore();
}
export function im(u, o, m, r) {
  u.save(), u.translate(o, m), u.shadowColor = "#ff736b", u.shadowBlur = 10, u.fillStyle = "#283246", u.beginPath(), u.arc(0, 0, r, 0, Math.PI * 2), u.fill(), u.shadowBlur = 0, u.strokeStyle = "#93a4bf", u.lineWidth = 2, u.stroke(), u.strokeStyle = "#ffb75c", u.lineWidth = 3, u.beginPath(), u.moveTo(r * .35, -r * .6), u.quadraticCurveTo(r * .85, -r * 1.35, r * 1.2, -r * .9), u.stroke(), u.fillStyle = "#ffdf77", u.beginPath(), u.arc(r * 1.2, -r * .9, 2.4, 0, Math.PI * 2), u.fill(), u.restore();
}
export function cm(u, o, m) {
  u.save(), u.translate(o, m), u.shadowColor = "#ffd870", u.shadowBlur = 12, u.fillStyle = "#a7652e", u.fillRect(-13, -4, 26, 16), u.beginPath(), u.arc(0, -4, 13, Math.PI, 0), u.fill(), u.shadowBlur = 0, u.fillStyle = "#ffd765", u.fillRect(-2, -16, 4, 28), u.fillRect(-14, 3, 28, 3), u.restore();
}
export function Ml(u, o, m, r, g, j) {
  if (!o?.complete || !o.naturalWidth) {
    j();
    return;
  }
  const B = g * o.naturalHeight / o.naturalWidth;
  u.drawImage(o, m - g / 2, r - B / 2, g, B);
}
export function FishingArcade({
  onBack: u,
  onShellsRewarded: o
}) {
  const m = React.useRef(null),
    r = React.useRef({}),
    g = React.useRef(sm()),
    j = React.useRef(0),
    B = React.useRef(null),
    U = React.useRef(!1),
    [N, y] = React.useState("idle"),
    [X, M] = React.useState({
      depth: 0,
      caught: 0,
      hint: "Выбери момент и забрось удочку."
    }),
    [R, H] = React.useState(null),
    [Y, P] = React.useState(null),
    [W, ee] = React.useState(null),
    [ie, w] = React.useState(!1),
    [I, ne] = React.useState(null),
    [oe, T] = React.useState(!1),
    [D, le] = React.useState(""),
    te = window.Telegram?.WebApp?.BackButton,
    Z = getAuthData(),
    V = React.useCallback(async () => {
      if (Z) try {
        const f = await fetch("/api/fishing/collection", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              initData: Z
            })
          }),
          {
            data: h
          } = await Xi(f);
        f.ok && ee(h);
      } catch {}
    }, [Z]),
    ae = React.useCallback((f, h) => {
      y(f.phase), M({
        depth: Math.round(f.depth),
        caught: f.stats.caught.length,
        hint: h ?? (f.phase === "descending" ? "Уворачивайся от рыб" : f.phase === "ascending" ? "Лови всё, что сможешь!" : f.phase === "slicing" ? "Разрежь улов!" : "Выбери момент и забрось удочку.")
      });
    }, []),
    Te = React.useCallback(async () => {
      if (oe) return;
      le(""), ne(null), U.current = !1;
      let f = null;
      if (Z) {
        T(!0);
        try {
          const p = await fetch("/api/fishing/start", {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                initData: Z
              })
            }),
            {
              data: G
            } = await Xi(p);
          if (!p.ok) throw new Error(G.error || "Не удалось начать рыбалку.");
          f = G.runToken, P(F => F && {
            ...F,
            rewardsRemaining: G.rewardsRemaining,
            rewardsDailyLimit: G.rewardsDailyLimit
          });
        } catch (p) {
          le(p instanceof Error ? p.message : "Не удалось начать рыбалку.");
          return;
        } finally {
          T(!1);
        }
      }
      B.current = f;
      const h = sm();
      h.phase = "descending", h.hintUntil = performance.now() + 1400, g.current = h, H(null), ae(h, "Уворачивайся от рыб");
    }, [Z, oe, ae]);
  React.useEffect(() => {
    if (te) return te.show(), te.onClick(u), () => {
      te.offClick(u), te.hide();
    };
  }, [u, te]), React.useEffect(() => {
    if (!Z) return;
    let f = !1;
    return fetch("/api/fishing/state", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        initData: Z
      })
    }).then(Xi).then(({
      response: h,
      data: p
    }) => {
      !f && h.ok && P(p);
    }).catch(() => {}), () => {
      f = !0;
    };
  }, [Z]), React.useEffect(() => {
    V();
  }, [V]), React.useEffect(() => {
    const f = B.current;
    !R || !f || !Z || U.current || (U.current = !0, fetch("/api/fishing/complete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        initData: Z,
        runToken: f,
        maxDepth: Math.round(R.maxDepth),
        caught: R.caught.length,
        caughtFish: R.caught.map(h => h.id)
      })
    }).then(Xi).then(({
      response: h,
      data: p
    }) => {
      if (!h.ok) throw new Error(p.error || "Не удалось сохранить улов.");
      const G = Number(p.reward?.shells || 0),
        F = !!p.rewarded;
      ne({
        rewarded: F,
        shells: G,
        catchName: String(p.reward?.catchName || ""),
        rarity: String(p.reward?.rarity || "")
      }), F && G > 0 && o?.(G), P(ce => ({
        rewardsRemaining: Number(p.rewardsRemaining),
        rewardsDailyLimit: Number(p.rewardsDailyLimit),
        bestDepth: Math.max(ce?.bestDepth || 0, Math.round(R.maxDepth)),
        fishCaught: (ce?.fishCaught || 0) + R.caught.length,
        leaders: p.leaders
      })), V();
    }).catch(h => le(h instanceof Error ? h.message : "Не удалось сохранить улов.")).finally(() => {
      B.current = null;
    }));
  }, [Z, V, o, R]), React.useEffect(() => {
    const f = [...Do.map(h => h.image), ...Object.values(ys), gn.chest, gn.bomb];
    for (const h of f) {
      const p = new Image();
      p.src = h, r.current[h] = p;
    }
  }, []), React.useEffect(() => {
    const f = m.current;
    if (!f) return;
    const h = f.getContext("2d");
    if (!h) return;
    let p = performance.now(),
      G = 0;
    const F = () => {
      const S = f.getBoundingClientRect(),
        xe = Math.min(window.devicePixelRatio || 1, 2);
      f.width = Math.max(1, Math.round(S.width * xe)), f.height = Math.max(1, Math.round(S.height * xe)), h.setTransform(f.width / Ee.logicalWidth, 0, 0, f.height / Ee.logicalHeight, 0, 0);
    };
    F();
    const ce = new ResizeObserver(F);
    ce.observe(f);
    const ue = S => {
        S.phase = "results", H({
          ...S.stats,
          caught: [...S.stats.caught]
        }), ae(S, "Раунд завершён");
      },
      Me = S => {
        for (; S.spawnDepth < S.depth + 210 && S.world.length < Ee.objectLimit;) {
          const xe = S.spawnDepth,
            ve = Math.random(),
            we = xe >= Ee.deepPrizeMinDepth && ve < Ee.deepPrizeChance ? "relic" : ve < Ee.chestSpawnChance ? "chest" : ve < Ee.chestSpawnChance + Ee.bombSpawnChance ? "bomb" : ve < .985 ? "fish" : "bonus",
            ye = Math.random() > .5 ? 1 : -1;
          S.world.push({
            id: S.nextId++,
            kind: we,
            fish: we === "fish" || we === "bonus" ? tb(xe) : void 0,
            x: Vt(26, 334),
            depth: xe,
            drift: ye * Vt(66, 105),
            wave: Vt(0, Math.PI * 2)
          }), S.spawnDepth += Ee.fishSpawnDistance + Vt(2, 13);
        }
      },
      Re = S => {
        const xe = S.sliceQueue.splice(0, 4),
          ve = [{
            x: 54,
            y: 0
          }, {
            x: 142,
            y: 16
          }, {
            x: 232,
            y: 8
          }, {
            x: 310,
            y: 24
          }];
        S.elapsed = 0, S.sliced = xe.map((we, ye) => ({
          id: S.nextId++ + 1e4,
          kind: "fish",
          fish: we,
          x: ve[ye].x + Vt(-18, 18),
          y: Ee.logicalHeight + 28 + ve[ye].y,
          vx: Vt(-52, 52),
          vy: Vt(-870, -740),
          rotation: Vt(-.45, .45),
          spin: Vt(-3.2, 3.2)
        })), xe.length > 2 && Math.random() < Ee.slicingBombChance && S.sliced.push({
          id: S.nextId++ + 1e4,
          kind: "bomb",
          x: Vt(80, 280),
          y: Ee.logicalHeight + 38,
          vx: Vt(-42, 42),
          vy: Vt(-820, -720),
          rotation: 0,
          spin: 3
        });
      },
      wt = S => {
        S.phase = "slicing", S.sliceQueue = [...S.stats.caught], S.hintUntil = performance.now() + 1400, Re(S), ae(S, "Разрежь улов!");
      },
      me = (S, xe, ve) => {
        if (S.phase === "idle" || S.phase === "results") return;
        const we = (S.left ? -1 : 0) + (S.right ? 1 : 0);
        if (S.hookX = yn(S.hookX + we * Ee.hookSpeed * xe, 19, Ee.logicalWidth - 19), S.trail = S.trail.map(ye => ({
          ...ye,
          life: ye.life - xe
        })).filter(ye => ye.life > 0), S.phase === "descending" || S.phase === "ascending") {
          const ye = S.depth / Ee.maxDepth,
            Bt = S.phase === "ascending" && S.stats.caught.length === 0 && S.ascentStartDepth - S.depth >= 100,
            He = S.phase === "descending" ? Ee.descendSpeed * (1 + Math.pow(ye, 1.65) * Ee.descendDepthBoost) : -(S.rapidReturn || Bt || S.stats.caught.length >= Ee.quickAscendCatchCount ? Ee.quickAscendSpeed : Ee.ascendSpeed);
          S.depth = yn(S.depth + He * xe, 0, Ee.maxDepth), S.stats.maxDepth = Math.max(S.stats.maxDepth, S.depth), Me(S);
          for (const ge of S.world) (ge.kind === "fish" || ge.kind === "bonus") && (ge.x += ge.drift * xe + Math.sin(ve / 170 + ge.wave) * xe * 17, (ge.x <= 19 || ge.x >= 341) && (ge.x = yn(ge.x, 19, 341), ge.drift *= -1));
          const Le = S.world.find(ge => !ge.collected && Math.abs(ge.depth - S.depth) < 11 && Math.abs(ge.x - S.hookX) < (ge.kind === "relic" ? 30 : ge.kind === "chest" ? 23 : ge.kind === "bomb" ? 26 : 19));
          if (Le) if (S.phase === "descending") Le.kind === "chest" ? (Le.collected = !0, S.stats.chests += 1) : Le.kind === "relic" ? (Le.collected = !0, S.stats.relics += 1, S.stats.reward += Ee.deepPrizeReward) : Le.kind === "bomb" ? (S.shakeUntil = ve + 300, S.phase = "ascending", S.ascentStartDepth = S.depth, S.hintUntil = ve + 1400, ae(S, "Лови всё, что сможешь!")) : (S.phase = "ascending", S.ascentStartDepth = S.depth, S.hintUntil = ve + 1400, ae(S, "Лови всё, что сможешь!"));else if (Le.kind === "fish" || Le.kind === "bonus") Le.collected = !0, Le.fish && S.stats.caught.push(Le.fish);else if (Le.kind === "chest") Le.collected = !0, S.stats.chests += 1;else if (Le.kind === "relic") Le.collected = !0, S.stats.relics += 1, S.stats.reward += Ee.deepPrizeReward;else {
            S.shakeUntil = ve + 320;
            const ge = Math.ceil(S.stats.caught.length * Ee.bombCatchPenalty);
            S.stats.caught.splice(Math.max(0, S.stats.caught.length - ge), ge);
          }
          S.world = S.world.filter(ge => !ge.collected && (S.phase === "ascending" ? ge.depth >= 0 && ge.depth < S.depth + 260 : ge.depth > S.depth - 170 && ge.depth < S.depth + 260)), S.phase === "descending" && S.depth >= Ee.maxDepth && (S.phase = "ascending", S.rapidReturn = !0, S.ascentStartDepth = S.depth, S.hintUntil = ve + 1400, ae(S, "Лови всё, что сможешь!")), S.phase === "ascending" && S.depth <= 0 && wt(S);
        } else if (S.phase === "slicing") {
          S.elapsed += xe;
          for (const ye of S.sliced) ye.x += ye.vx * xe, ye.y += ye.vy * xe, ye.vy += 850 * xe, ye.rotation += ye.spin * xe;
          S.sliced = S.sliced.filter(ye => !ye.cut && ye.y < Ee.logicalHeight + 80), (S.elapsed >= Ee.slicingDuration || S.sliced.length === 0) && (S.sliceQueue.length > 0 ? (Re(S), S.hintUntil = ve + 900, ae(S, "Следующая партия улова!")) : ue(S));
        }
        ve > G && (G = ve + 120, ae(S, ve < S.hintUntil ? void 0 : ""));
      },
      K = (S, xe) => {
        const ve = Ee.logicalWidth,
          we = Ee.logicalHeight,
          ye = xe < S.shakeUntil ? Vt(-4, 4) : 0;
        h.save(), h.clearRect(0, 0, ve, we), h.translate(ye, ye);
        const Bt = h.createLinearGradient(0, 0, 0, we);
        Bt.addColorStop(0, "#21345f"), Bt.addColorStop(.3, "#075277"), Bt.addColorStop(1, "#04172f"), h.fillStyle = Bt, h.fillRect(0, 0, ve, we);
        for (let He = -30; He < we; He += 36) {
          const Le = He + S.depth * .42 % 36;
          h.strokeStyle = "rgba(99,225,255,.14)", h.lineWidth = 2, h.beginPath(), h.moveTo(0, Le), h.quadraticCurveTo(ve * .45, Le - 14, ve, Le - 3), h.stroke();
        }
        if (S.phase !== "slicing") {
          const He = Ee.surfaceY - S.depth * .72;
          He > -32 && (h.fillStyle = "rgba(62,34,91,.75)", h.fillRect(0, 0, ve, He), h.strokeStyle = "rgba(171,242,255,.52)", h.beginPath(), h.moveTo(0, He), h.lineTo(ve, He), h.stroke());
          const Le = (_e, at, va, ht, na, ol = "source-over") => {
              const oa = r.current[_e];
              !oa?.complete || !oa.naturalWidth || (h.save(), h.globalAlpha = na, h.globalCompositeOperation = ol, h.drawImage(oa, at, va, ht, ht * oa.naturalHeight / oa.naturalWidth), h.restore());
            },
            ge = (_e, at, va = "source-over") => {
              const ht = r.current[_e];
              if (!ht?.complete || !ht.naturalWidth) return;
              const na = Math.max(ve / ht.naturalWidth, we / ht.naturalHeight),
                ol = ht.naturalWidth * na,
                oa = ht.naturalHeight * na;
              h.save(), h.globalAlpha = at, h.globalCompositeOperation = va, h.drawImage(ht, (ve - ol) / 2, (we - oa) / 2, ol, oa), h.restore();
            };
          S.depth < 185 ? ge(ys.surface, .19, "screen") : S.depth < 520 ? ge(ys.midwater, .13, "screen") : (ge(ys.deepWater, .28, "screen"), Le(ys.seafloor, 0, we * .34, ve, .14, "screen"));
          for (const _e of S.world) {
            const at = we * .49 + (_e.depth - S.depth) * 2.7 + (_e.kind === "fish" || _e.kind === "bonus" ? Math.sin(xe / 210 + _e.wave) * 4 : 0);
            at < -58 || at > we + 58 || (_e.kind === "bomb" ? Ml(h, r.current[gn.bomb], _e.x, at, 55, () => im(h, _e.x, at, 16)) : _e.kind === "relic" ? (h.save(), h.shadowColor = "#d06cff", h.shadowBlur = 20, Ml(h, r.current[gn.chest], _e.x, at, 70, () => cm(h, _e.x, at)), h.restore()) : _e.kind === "chest" ? Ml(h, r.current[gn.chest], _e.x, at, 48, () => cm(h, _e.x, at)) : Ml(h, r.current[_e.fish?.image ?? ""], _e.x, at, (_e.fish?.size ?? 20) * 2.45, () => jo(h, _e.x, at, _e.fish?.size ?? 20, _e.kind === "bonus" ? "#fff0a5" : _e.fish?.color ?? "#63e2ff", _e.drift >= 0 ? 1 : -1)));
          }
          const gt = we * .49 + (Ee.maxDepth - S.depth) * 2.7;
          gt < we + 50 && (h.fillStyle = "#6a4939", h.fillRect(0, gt, ve, we - gt), h.strokeStyle = "#a97a5b", h.lineWidth = 5, h.beginPath(), h.moveTo(0, gt), h.lineTo(ve, gt), h.stroke());
          const st = we * .49;
          if (S.depth > 500) {
            const _e = h.createRadialGradient(S.hookX, st, 28, S.hookX, st, 158);
            _e.addColorStop(0, "rgba(2, 13, 33, 0)"), _e.addColorStop(.42, "rgba(2, 13, 33, .05)"), _e.addColorStop(.68, "rgba(2, 13, 33, .94)"), _e.addColorStop(1, "rgba(2, 13, 33, 1)"), h.fillStyle = _e, h.fillRect(0, 0, ve, we);
          }
          h.strokeStyle = "rgba(224,249,255,.75)", h.lineWidth = 1.3, h.beginPath(), h.moveTo(S.hookX, 0), h.lineTo(S.hookX, st - 6), h.stroke(), h.strokeStyle = "#e8f9ff", h.lineWidth = 3, h.beginPath(), h.arc(S.hookX, st, 10, -.8, Math.PI * .8), h.stroke(), h.fillStyle = "#70e6ff", h.beginPath(), h.arc(S.hookX, st - 9, 3, 0, Math.PI * 2), h.fill();
          for (let _e = 0; _e < S.stats.caught.length; _e++) {
            const at = S.stats.caught[_e];
            Ml(h, r.current[at.image], S.hookX + (_e % 2 ? 12 : -12), st + 20 + Math.floor(_e / 2) * 13, 25, () => jo(h, S.hookX, st + 20, 6, at.color));
          }
          if (S.depth > 55 && Math.floor(xe / 3500) % 3 !== 2) {
            h.save(), h.globalCompositeOperation = "screen";
            for (let _e = 0; _e < 9; _e++) {
              const at = (xe / 6200 * (.7 + _e % 3 * .12) + _e * .173) % 1,
                va = 22 + ((_e * 79 + Math.sin(xe / 1200 + _e) * 12) % 316 + 316) % 316,
                ht = we + 20 - at * (we + 70),
                na = 2.1 + _e % 4 * .9;
              h.globalAlpha = .18 + (1 - at) * .26, h.strokeStyle = "#bff6ff", h.lineWidth = 1.1, h.beginPath(), h.arc(va, ht, na, 0, Math.PI * 2), h.stroke(), h.fillStyle = "rgba(148,229,255,.28)", h.beginPath(), h.arc(va - na * .25, ht - na * .25, Math.max(.7, na * .28), 0, Math.PI * 2), h.fill();
            }
            h.restore();
          }
        } else {
          h.fillStyle = "rgba(4,18,45,.55)", h.fillRect(0, 0, ve, we);
          for (const He of S.sliced) h.save(), h.translate(He.x, He.y), h.rotate(He.rotation), He.kind === "bomb" ? Ml(h, r.current[gn.bomb], 0, 0, 56, () => im(h, 0, 0, 14)) : Ml(h, r.current[He.fish?.image ?? ""], 0, 0, (He.fish?.size ?? 20) * 3, () => jo(h, 0, 0, He.fish?.size ?? 20, He.fish?.color ?? "#63e2ff")), h.restore();
        }
        if (S.trail.length > 1) {
          h.save(), h.lineCap = "round", h.lineJoin = "round";
          for (let He = 1; He < S.trail.length; He++) {
            const Le = S.trail[He - 1],
              ge = S.trail[He];
            h.strokeStyle = `rgba(196,249,255,${Math.min(Le.life, ge.life) / .24})`, h.lineWidth = 2 + ge.life * 12, h.beginPath(), h.moveTo(Le.x, Le.y), h.lineTo(ge.x, ge.y), h.stroke();
          }
          h.restore();
        }
        h.restore();
      },
      re = S => {
        const xe = Math.min(.033, (S - p) / 1e3);
        p = S;
        const ve = g.current;
        me(ve, xe, S), K(ve, S), j.current = requestAnimationFrame(re);
      };
    return j.current = requestAnimationFrame(re), () => {
      cancelAnimationFrame(j.current), ce.disconnect();
    };
  }, [ae]), React.useEffect(() => {
    const f = G => F => {
        (F.key === "ArrowLeft" || F.key.toLowerCase() === "a") && (g.current.left = G), (F.key === "ArrowRight" || F.key.toLowerCase() === "d") && (g.current.right = G);
      },
      h = f(!0),
      p = f(!1);
    return window.addEventListener("keydown", h), window.addEventListener("keyup", p), () => {
      window.removeEventListener("keydown", h), window.removeEventListener("keyup", p);
    };
  }, []);
  const je = f => {
      const h = f.currentTarget.getBoundingClientRect();
      return {
        x: (f.clientX - h.left) * Ee.logicalWidth / h.width,
        y: (f.clientY - h.top) * Ee.logicalHeight / h.height
      };
    },
    k = (f, h) => {
      const p = g.current,
        G = performance.now();
      p.trail.push({
        ...h,
        life: .24
      });
      for (const F of p.sliced) {
        if (F.cut || eb(F.x, F.y, f.x, f.y, h.x, h.y) > (F.kind === "bomb" ? 20 : 24)) continue;
        if (F.kind === "bomb") {
          p.shakeUntil = G + 360, p.stats.combo = 0, p.stats.reward = Math.max(0, Math.floor(p.stats.reward * (1 - Ee.slicingBombPenalty))), F.cut = !0;
          continue;
        }
        F.cut = !0, p.stats.sliced += 1, p.stats.combo = G - p.lastSlice < Ee.comboWindowMs ? p.stats.combo + 1 : 1, p.stats.bestCombo = Math.max(p.stats.bestCombo, p.stats.combo), p.lastSlice = G;
        const ce = Ee.comboMultipliers[Math.min(p.stats.combo, 4) - 1] ?? 1.3;
        p.stats.reward += Math.round((F.fish?.reward ?? 5) * ce);
      }
    },
    O = f => {
      const h = g.current,
        p = je(f);
      f.currentTarget.setPointerCapture(f.pointerId), h.pointer = p, (h.phase === "descending" || h.phase === "ascending") && (h.hookX = yn(p.x, 19, 341));
    },
    L = f => {
      const h = g.current,
        p = je(f);
      (h.phase === "descending" || h.phase === "ascending") && (h.hookX = yn(p.x, 19, 341)), h.phase === "slicing" && h.pointer && k(h.pointer, p), h.pointer = p;
    },
    se = () => {
      g.current.pointer = void 0;
    },
    C = N === "descending" || N === "ascending" || N === "slicing";
  return jsxRuntime.jsxs("section", {
    className: `mc-fishing-page mc-fishing-arcade ${C ? "is-diving" : ""}`,
    children: [!te && jsxRuntime.jsxs("button", {
      className: "mc-wallet-back",
      onClick: u,
      children: [jsxRuntime.jsx("span", {
        children: jsxRuntime.jsx(IconChevronLeft, { "aria-hidden": "true" })
      }), " Назад"]
    }), jsxRuntime.jsxs("header", {
      className: "mc-fishing-heading",
      children: [jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsx("p", {
          children: "ЛЕТНИЙ СЕЗОН"
        }), jsxRuntime.jsx("h1", {
          children: "Рыбалка"
        }), jsxRuntime.jsx("small", {
          children: "Лови рыбу и редкие находки"
        })]
      }), jsxRuntime.jsxs("strong", {
        children: [X.caught, jsxRuntime.jsx("small", {
          children: "улов"
        })]
      })]
    }), jsxRuntime.jsxs("section", {
      className: "mc-fishing-lake mc-fishing-canvas-lake",
      children: [jsxRuntime.jsx("canvas", {
        ref: m,
        onPointerDown: O,
        onPointerMove: L,
        onPointerUp: se,
        onPointerCancel: se
      }), jsxRuntime.jsxs("div", {
        className: "mc-fishing-status",
        children: [jsxRuntime.jsx("b", {
          children: N === "descending" || N === "ascending" ? `ГЛУБИНА ${X.depth} м` : N === "slicing" ? `РАЗРЕЗАНО ${R?.sliced ?? g.current.stats.sliced}` : N === "results" ? "УЛОВ ДОСТАВЛЕН" : "ГОТОВЫ К ЗАБРОСУ"
        }), (N === "descending" || N === "ascending") && jsxRuntime.jsx("span", {
          className: "mc-fishing-depth-meter",
          children: jsxRuntime.jsx("i", {
            style: {
              width: `${Math.min(100, X.depth / Ee.maxDepth * 100)}%`
            }
          })
        }), jsxRuntime.jsx("small", {
          children: X.hint
        })]
      })]
    }), !C && Y && jsxRuntime.jsxs("p", {
      className: "mc-fishing-reward-limit",
      children: ["🎁 Награды сегодня: ", jsxRuntime.jsxs("b", {
        children: [Y.rewardsRemaining, " / ", Y.rewardsDailyLimit]
      }), Y.rewardsRemaining ? " — забросы с ракушками" : " — дальше можно играть без награды"]
    }), !C && D && jsxRuntime.jsx("p", {
      className: "mc-fishing-api-error",
      children: D
    }), N === "idle" && jsxRuntime.jsx("button", {
      className: "mc-fishing-cast",
      onClick: Te,
      disabled: oe,
      children: oe ? "Подготавливаем заброс…" : jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: ["Забросить удочку ", jsxRuntime.jsx(IconArrowRight, {})]
      })
    }), N === "slicing" && jsxRuntime.jsx("p", {
      className: "mc-fishing-tip",
      children: "Проводи пальцем или мышью по рыбам. Бомбы лучше не трогать."
    }), N === "results" && R && jsxRuntime.jsxs("section", {
      className: "mc-fishing-results",
      children: [jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsx("small", {
          children: "УЛОВ"
        }), jsxRuntime.jsxs("b", {
          children: [R.caught.length, " рыб"]
        })]
      }), jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsx("small", {
          children: "Редкие"
        }), jsxRuntime.jsx("b", {
          children: R.caught.filter(f => f.rarity === "rare" || f.rarity === "epic" || f.rarity === "legendary").length
        })]
      }), jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsx("small", {
          children: "Глубина"
        }), jsxRuntime.jsxs("b", {
          children: [Math.round(R.maxDepth), " м"]
        })]
      }), jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsx("small", {
          children: "Разрезано"
        }), jsxRuntime.jsxs("b", {
          children: [Math.min(R.sliced, R.caught.length), " / ", R.caught.length]
        })]
      }), jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsx("small", {
          children: "Combo"
        }), jsxRuntime.jsxs("b", {
          children: ["x", Math.max(1, R.bestCombo)]
        })]
      }), jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsx("small", {
          children: "Сундуки"
        }), jsxRuntime.jsx("b", {
          children: R.chests
        })]
      }), jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsx("small", {
          children: "Глубокие призы"
        }), jsxRuntime.jsx("b", {
          children: R.relics
        })]
      }), I && jsxRuntime.jsxs("div", {
        className: "mc-fishing-server-reward",
        children: [jsxRuntime.jsx("small", {
          children: I.rewarded ? "НАГРАДА ВЫДАНА" : "ТРЕНИРОВКА"
        }), jsxRuntime.jsx("b", {
          children: I.rewarded ? `+${I.shells} ракушек` : "Без награды"
        }), jsxRuntime.jsx("em", {
          children: I.catchName
        })]
      }), jsxRuntime.jsxs("footer", {
        children: [jsxRuntime.jsx("span", {
          children: I ? I.rewarded ? "Ракушки начислены" : "Заброс без награды" : "Сохраняем улов…"
        }), jsxRuntime.jsxs("button", {
          className: "mc-fishing-cast",
          onClick: Te,
          disabled: oe,
          children: ["Забросить ещё раз ", jsxRuntime.jsx(IconArrowRight, {})]
        })]
      })]
    }), !C && N !== "results" && jsxRuntime.jsx("p", {
      className: "mc-fishing-tip",
      children: "На спуске избегай рыб и бомб. Сундуки можно подобрать, а на подъёме — собирай улов."
    }), !C && W && jsxRuntime.jsxs("button", {
      className: "mc-fishing-collection-button",
      onClick: () => w(!0),
      children: [jsxRuntime.jsx("span", {
        children: "🐠"
      }), jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsx("b", {
          children: "Коллекция улова"
        }), jsxRuntime.jsxs("small", {
          children: ["Открыто: ", W.collectedTypes, " / ", W.totalTypes, " · Всего поймано: ", W.totalCaught]
        })]
      }), jsxRuntime.jsx("i", {
        children: jsxRuntime.jsx(IconChevronRight, { "aria-hidden": "true" })
      })]
    }), !C && Y && jsxRuntime.jsxs("section", {
      className: "mc-fishing-leaderboard",
      children: [jsxRuntime.jsxs("header", {
        children: [jsxRuntime.jsx("b", {
          children: "Рейтинг рыбалки"
        }), jsxRuntime.jsx("small", {
          children: "Топ текущего ивента"
        })]
      }), jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsxs("section", {
          children: [jsxRuntime.jsx("h3", {
            children: "Глубина"
          }), Y.leaders.depth.length ? Y.leaders.depth.map(f => jsxRuntime.jsxs("p", {
            children: [jsxRuntime.jsx("i", {
              children: f.place
            }), jsxRuntime.jsx("span", {
              children: f.name
            }), jsxRuntime.jsxs("b", {
              children: [f.value, " м"]
            })]
          }, `depth-${f.place}-${f.name}`)) : jsxRuntime.jsx("small", {
            children: "Пока нет погружений"
          })]
        }), jsxRuntime.jsxs("section", {
          children: [jsxRuntime.jsx("h3", {
            children: "Улов"
          }), Y.leaders.fish.length ? Y.leaders.fish.map(f => jsxRuntime.jsxs("p", {
            children: [jsxRuntime.jsx("i", {
              children: f.place
            }), jsxRuntime.jsx("span", {
              children: f.name
            }), jsxRuntime.jsxs("b", {
              children: [f.value, " рыб"]
            })]
          }, `fish-${f.place}-${f.name}`)) : jsxRuntime.jsx("small", {
            children: "Пока нет улова"
          })]
        })]
      })]
    }), ie && W && jsxRuntime.jsxs("section", {
      className: "mc-fishing-collection",
      role: "dialog",
      "aria-modal": "true",
      "aria-label": "Коллекция улова",
      children: [jsxRuntime.jsx("button", {
        className: "mc-fishing-collection-backdrop",
        onClick: () => w(!1),
        "aria-label": "Закрыть коллекцию"
      }), jsxRuntime.jsxs("article", {
        children: [jsxRuntime.jsxs("header", {
          children: [jsxRuntime.jsxs("div", {
            children: [jsxRuntime.jsx("small", {
              children: "РЫБАЛКА"
            }), jsxRuntime.jsx("h2", {
              children: "Коллекция улова"
            }), jsxRuntime.jsxs("p", {
              children: [W.collectedTypes, " из ", W.totalTypes, " видов · всего ", W.totalCaught, " уловов"]
            })]
          }), jsxRuntime.jsx("button", {
            className: "mc-icon-button",
            onClick: () => w(!1),
            "aria-label": "Закрыть",
            children: jsxRuntime.jsx(IconX, { "aria-hidden": "true" })
          })]
        }), jsxRuntime.jsx("div", {
          className: "mc-fishing-collection-grid",
          children: W.entries.map(f => {
            const h = Do.find(p => p.id === f.id);
            return jsxRuntime.jsxs("section", {
              className: `${f.caught ? "caught" : "missing"} rarity-${f.rarity}`,
              children: [jsxRuntime.jsx("i", {
                children: f.caught && h ? jsxRuntime.jsx("img", {
                  src: h.image,
                  alt: ""
                }) : "?"
              }), jsxRuntime.jsx("b", {
                children: f.caught ? f.name : "Неизвестный улов"
              }), jsxRuntime.jsx("small", {
                children: f.caught ? f.spot : "Ещё не поймано"
              }), f.caught && jsxRuntime.jsxs("em", {
                children: ["×", f.amount]
              })]
            }, f.id);
          })
        })]
      })]
    })]
  });
}
